import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const ParentAuthContext = createContext(null);
export const useParentAuth = () => useContext(ParentAuthContext);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = 'nucleus_parent_token';

export function ParentAuthProvider({ children }) {
  const [parent, setParent] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = typeof window !== 'undefined' ? localStorage.getItem(TOKEN_KEY) : null;

  const refresh = useCallback(async () => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (!t) { setParent(null); setLoading(false); return; }
    try {
      const r = await axios.get(`${API}/family/auth/me`, { headers: { Authorization: `Bearer ${t}` } });
      setParent(r.data.parent);
    } catch (e) {
      if (e.response?.status === 403 || e.response?.status === 401) {
        localStorage.removeItem(TOKEN_KEY);
      }
      setParent(null);
    }
    setLoading(false);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const r = await axios.post(`${API}/family/auth/login`, { email, password });
    localStorage.setItem(TOKEN_KEY, r.data.token);
    setParent(r.data.parent);
    return r.data.parent;
  };
  const register = async (payload) => {
    const r = await axios.post(`${API}/family/auth/register`, payload);
    localStorage.setItem(TOKEN_KEY, r.data.token);
    setParent(r.data.parent);
    return r.data.parent;
  };
  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setParent(null);
  };
  const headers = () => {
    const t = localStorage.getItem(TOKEN_KEY);
    return t ? { Authorization: `Bearer ${t}` } : {};
  };

  return (
    <ParentAuthContext.Provider value={{
      parent, loading, login, register, logout, headers, refresh,
      isAuthenticated: !!parent,
    }}>
      {children}
    </ParentAuthContext.Provider>
  );
}
